<template>
  <el-dialog
    title="马帮出库履历"
    :visible.sync="visible"
    width="1000px"
    custom-class="box-help-dialog"
  >
    <div class="modal-table-wrap">
      <table class="log-table">
        <thead>
          <tr>
            <th>SKU</th>
            <th>出库数量</th>
            <th>出库时间</th>
            <th>当前剩余数量</th>
            <th>仓位</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!logs.length" class="empty-row">
            <td colspan="5">
              <div class="empty-box">
                <strong>暂无马帮出库履历</strong>
                <span>执行马帮出库后展示 SKU 出库明细</span>
              </div>
            </td>
          </tr>
          <tr v-for="row in logs" :key="row.sku + row.outboundTime">
            <td><span class="sku-code">{{ row.sku }}</span></td>
            <td><strong>{{ row.qty }}</strong></td>
            <td>{{ row.outboundTime }}</td>
            <td>{{ row.currentRemainingQty }}</td>
            <td>{{ row.location }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "OutboundLogDialog",
  data() {
    return {
      // 弹窗显示状态。
      visible: false,
      // 当前展示的马帮出库履历列表。
      logs: [],
    };
  },
  methods: {
    // 供父组件通过 $refs 调用，打开弹窗并写入履历数据。
    open: function (logs) {
      this.logs = logs || [];
      this.visible = true;
    },
    // 关闭弹窗并清空履历数据。
    close: function () {
      this.visible = false;
      this.logs = [];
    },
  },
};
</script>

<style scoped>
.modal-table-wrap {
  max-height: 420px;
  overflow: auto;
}

.log-table {
  width: 100%;
  min-width: 700px;
  border-collapse: collapse;
  table-layout: fixed;
}

.log-table th,
.log-table td {
  height: 48px;
  padding: 8px 12px;
  border: 1px solid #e8ebf0;
  text-align: left;
  vertical-align: middle;
}

.log-table th {
  height: 46px;
  background: #fafafa;
  color: #333333;
  font-weight: 700;
}

.empty-row td {
  height: 260px;
  text-align: center;
}

.empty-box {
  display: grid;
  gap: 10px;
  justify-items: center;
}

.empty-box strong {
  font-size: 14px;
  font-weight: 500;
  color: #b5bac2;
}

.empty-box span {
  color: #8c939d;
}

.sku-code {
  color: #1688ff;
  overflow-wrap: anywhere;
}
</style>
